import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../dynamicFormBuilder/FormField'
import { GridLayout } from '../../common/GridLayout';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    Lookup,
} from "devextreme-react/data-grid";
import { FillFilters, GetDatePartOnly, GetFormatedDateWithTime } from '../../common/Utils'
import { SearchLayout } from './Layout';
import GridLayoutManager from '../../gridLayoutCustomization/GridLayoutManager';
import '../../common/css/searchPage.css';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];


const List = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const id = useRef(null);
    const dataGrid = useRef(null);

    const gridKey = "18e2717e-5dbf-4215-b0ee-d743197a44c8";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
    const initialFormFields = {
        Name: '',
        Description: ''
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length == 1) {
            id.current = selectedRowsData[0].Id;
        }
        else {
            id.current = '';
        }

        setIsEditButtonDisabled(!isEditButtonDisabled);
    };

    const handelEditClick = () => {
        const buttonUrl = "/ai/edit-vectorstore?id=" + id.current;
    history.push(buttonUrl);
    };

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    const handleSearch = (e) => {
        e.event.stopPropagation();
        let datasource = loadDatasource();
        const filters = FillFilters(formFields);
        datasource.filter(filters);
        setResultData(datasource);
    };
    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
    }
    useEffect(() => {
        setResultData(loadDatasource);  
    }, [formFields]);

    const handleFormLoad = useCallback(() => {
       // loadLookupFromStaticData(formRefs, "STATUS", statuses);

    }, []);

    const handleFieldChange = useCallback((name, value) => {
        // console.log(name, value);
    }, []);


    const loadDatasource = () => {
        var url = "ai/vectorstore/GetVectorStores";
        let store = createStore({
            key: 'Id',
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        const dataSource = new DataSource({ store: store });
        return dataSource;
    }
    const [resultData, setResultData] = useState(null);

    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <div id="accordion" className="search-page-accordion">
                    <AccordionReact
                        dataSource={searchpanel}
                        collapsible={true}
                        multiple={false}
                        animationDuration={300}
                        selectedItems={selectedItems}
                        onSelectionChanged={e => {
                            if (e.currentTarget === e.target) {
                                selectionChanged(e, e.target);
                            }
                        }}
                        itemTitleRender={() => (
                            <Toolbar className="accordian-toolbar">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2
                                            }}
                                        >
                                            Enter Your Query For Vector Store Data Entry (Returns Max 100 Records)
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                            </Toolbar>
                        )}
                        itemRender={(itemProps) => (
                            <FormField
                                currrentUser={currentUser}
                                layoutId='3dd65d24-cdab-4ff8-b60e-80b8077277e3'
                                layoutName='AIVectorStoreDataEntrySearchForm'
                                defaultFormSchema={SearchLayout}
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldValueChange={handleFieldChange}
                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                formRefs={formRefs}
                                onFormLoad={handleFormLoad}
                                noSpacingBeforeFirstRow={true}
                            />
                        )}
                        id="accordion-container" className="accordion-height"
                    />
                </div>
                <div className="search-page-grid-container">
                    <DataGrid

                        onExporting={(e) => {
                            if (window.handleDevExtremeDataGridExport) {
                                window.handleDevExtremeDataGridExport(e);
                            }
                        }}
                        ref={dataGrid}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        dataSource={resultData}
                        showBorders={true}
                        hoverStateEnabled={true}
                        className="search-page-grid"
                        onSelectionChanged={(e) => onSelectionChanged(e)}
                        remoteOperations={true}
                        searchEnabled={true}
                        columnAutoWidth={true}
                    >
                            <ColumnChooser
                                enabled={true}
                                title="Choose Column"
                                width={290}
                                height={290}
                                sortOrder="asc"
                            >
                                <ColumnChooserSearch
                                    enabled={true}
                                    editorOptions={{ placeholder: 'Search column' }} />
                            </ColumnChooser>
                            <Export enabled={true} allowExportSelectedData={true} />
                            <Selection mode="multiple" />
                            <Sorting visible={true} mode="multiple" />
                            <Paging enabled={false} />
                            <FilterRow visible={true} />
                            <FilterPanel visible={true} />
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={false} />
                            <StateStoring
                                enabled={true}
                                type="custom"
                                customLoad={loadState}
                                storageKey={gridKey}
                                customSave={saveState}
                            />
                            <FilterRow visible={true} />
                            <Column dataType="string" caption='Id' dataField='Id'  />
                            <Column dataType="string" caption='Name' dataField='Name'  />
                            <Column dataType="string" caption='Description' dataField='Description'  />
                            <Column dataType="number" caption='Status' dataField='Status'  />
                            <Column dataType="number" caption='Created At (Unix timestamp)' dataField='CreatedAt'  />
                            <Column dataType="string" caption='Expires After Anchor' dataField='ExpiresAfter.Anchor'  />
                            <Column dataType="number" caption='Expires After Days' dataField='ExpiresAfter.Days'  />
                            <Column dataType="number" caption='Files Cancelled' dataField='FileCounts.Cancelled'  />
                            <Column dataType="number" caption='Files Completed' dataField='FileCounts.Completed'  />
                            <Column dataType="number" caption='Files Failed' dataField='FileCounts.Failed'  />
                            <Column dataType="number" caption='Files In Progress' dataField='FileCounts.InProgress'  />
                            <Column dataType="number" caption='Files Total' dataField='FileCounts.Total'  />

                            <GridToolbar>
                                <GridToolbarItem location="before">
                                    <Button
                                        disabled={isEditButtonDisabled}
                                        onClick={handelEditClick}
                                        type="default"
                                        text="Edit"
                                    ></Button>
                                </GridToolbarItem>
                                <GridToolbarItem location="before">
                                    <div>
                                        <Link to="/ai/add-vectorstore">
                                            <Button
                                                type="default"
                                                className="gridTopButton"
                                                text="Create"
                                            ></Button>
                                        </Link>
                                    </div>
                                </GridToolbarItem>
                                 <GridToolbarItem location="after">
                                 <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                                </GridToolbarItem>
                                <GridToolbarItem name="exportButton" />
                                <GridToolbarItem name="columnChooserButton" />
                            </GridToolbar>
                    </DataGrid>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}
export default connect(mapStateToProps)(List);